import React from "react";

import { EsgFileIcon } from "assets";

export const SCOPE_DOCUMENT_UPLOAD_PAGE_SCOPE3 = {
  ABSOLUTE_PATH: "/documents/scope-upload-scope3",
  PATH: "",
  TITLE: "Document scope upload",
  ICON: <EsgFileIcon />,
  renderMenu: true,
};
